import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiOriginalsResponse } from '@wix/da-papi-types';
import Refresh from '@wix/da-ds/pkg/Icons/16x16/Refresh';
import { useStream } from '@wix/da-shared-react/pkg/utils/hooks/useStream';
import OrdersSectionTitle from '../../OrdersSectionTitle';
import OrdersList from '../OrdersList';
import OrdersByStatusEmptyState from '../../OrdersByStatusEmptyState';
import { STUDIO_ORDERS_IN_PROGRESS_STREAM } from '../../../../../constants';

const InProgressOrdersList: React.FC = () => {
  const { t } = useTranslation();
  const {
    items: results,
    hasMore,
    fetchNext,
  } = useStream<PapiOriginalsResponse>(
    STUDIO_ORDERS_IN_PROGRESS_STREAM.streamId,
    STUDIO_ORDERS_IN_PROGRESS_STREAM.streamThrottle,
    STUDIO_ORDERS_IN_PROGRESS_STREAM.streamConfig
  );

  if (results.length < 1) {
    return (
      <OrdersByStatusEmptyState
        headerTitle={t('studio.orders.status.in_progress')}
        headerIcon={Refresh}
        text={t('studio.orders.status.in_progress.emptyState')}
      />
    );
  }

  return (
    <OrdersList
      heading={<OrdersSectionTitle title={t('studio.orders.status.in_progress')} icon={Refresh} />}
      results={results}
      hasMore={hasMore}
      fetchNext={fetchNext}
    />
  );
};
InProgressOrdersList.displayName = 'InProgressOrdersList';

export default InProgressOrdersList;
